/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$box-padding-desktop-l: 48px !default;
$box-padding-desktop: 40px !default;
$box-padding-tablet: 32px !default;
$box-padding-mobile: 24px !default;
$box-border-width: 0 !default;
$box-border-radius: 0 !default;
$box-link-hover-color: none !default; // set this to true in box json definition if you'd like to overwrite --linkHoverColor per scheme

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  @include slotted-margins("*:not([slot])");
}

.#{$prefix}box {
  background-color: v(backgroundColor);
  padding: $box-padding-desktop-l;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  border-width: $box-border-width;
  border-radius: $box-border-radius;
  border-style: solid;
  border-color: v(borderColor);
  color: v(color);

  &.#{$prefix}horizontal-alignment {
    &-center {
      align-items: center;
      text-align: center;
    }

    &-right {
      align-items: flex-end;
      text-align: right;
    }
  }

  &.#{$prefix}vertical-alignment {
    &-center {
      justify-content: center;
    }

    &-bottom {
      justify-content: flex-end;
    }
  }

  &.#{$prefix}gradient {
    background: v(gradientColor);
  }

  &.#{$prefix}active {
    border-color: v(activeBorderColor);
    background-color: v(activeBackgroundColor);
  }

  &.#{$prefix}offset {
    margin: 0 -#{$box-padding-desktop-l} 0 -#{$box-padding-desktop-l};
  }
}

:host(.container-breakpoint-1200) {
  .#{$prefix}box {
    padding: $box-padding-desktop;

    &.#{$prefix}offset {
      margin: 0 -#{$box-padding-desktop} 0 -#{$box-padding-desktop};
    }
  }
}

:host(.container-breakpoint-800) {
  .#{$prefix}box {
    padding: $box-padding-tablet;

    &.#{$prefix}offset {
      margin: 0 -#{$box-padding-tablet} 0 -#{$box-padding-tablet};
    }
  }
}

:host(.container-breakpoint-400) {
  .#{$prefix}box {
    padding: $box-padding-mobile;

    &.#{$prefix}offset {
      margin: 0 -#{$box-padding-mobile} 0 -#{$box-padding-mobile};
    }
  }
}

::slotted(eon-ui-link) {
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}
